"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parserSeemsToBeTSESLint = parserSeemsToBeTSESLint;
function parserSeemsToBeTSESLint(parser) {
    return !!parser && /(?:typescript-eslint|\.\.)[\w/\\]*parser/.test(parser);
}
//# sourceMappingURL=parserSeemsToBeTSESLint.js.map